import { Box } from 'grommet';
import { Omit } from 'grommet/utils';
import React, { PropsWithChildren } from 'react';
import styled, { DefaultTheme } from 'styled-components/macro';

export interface AlertProps {
  type: 'success' | 'warning' | 'error';
}

const typeBackgroundColor = (type: AlertProps['type'], colors: DefaultTheme['global']['colors']) => {
  switch (type) {
    case 'success':
      return colors['con-success'];
    case 'warning':
      return colors['con-warning'];
    case 'error':
      return colors['con-error'];
    default:
      return colors.white;
  }
};
const typeColor = (type: AlertProps['type'], colors: DefaultTheme['global']['colors']) => {
  switch (type) {
    case 'error':
      return colors.white;
    default:
      return colors.black;
  }
};

const StyledBox = styled(Box)<AlertProps>`
  border-radius: 3px;
  color: ${({
    type,
    theme: {
      global: { colors },
    },
  }) => typeColor(type, colors)};
  background-color: ${({
    type,
    theme: {
      global: { colors },
    },
  }) => typeBackgroundColor(type, colors)};
`;

const Alert: React.FC<PropsWithChildren<AlertProps>> = React.memo(props => {
  return (
    <StyledBox {...props} pad="small">
      {props.children}
    </StyledBox>
  );
});

export const AlertSuccess = (props: Omit<AlertProps, 'type'>) => <Alert type="success" {...props} />;
export const AlertWarning = (props: Omit<AlertProps, 'type'>) => <Alert type="warning" {...props} />;
export const AlertError = (props: Omit<AlertProps, 'type'>) => <Alert type="error" {...props} />;
